<template>
	<span>
		<span v-if="connection.isActive === 'false'">
			<b-badge variant="secondary">Inactive</b-badge>
		</span>
		<span v-else>
			<b-badge variant="success">Active</b-badge>
		</span>
	</span>
</template>

<script>
export default {
	name: 'connection-status',
	props: {
		connection: {
			type: Object,
			required: true
		}
	}
};
</script>

<style></style>